import { Clickstream } from '@gojek/clickstream-web'
import { products } from '@gojek/web-trip-tracker-protos';
import React, { createContext, useContext } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { deepMergeObject } from '../helpers/deepMergeObject';

export const clickstream = new Clickstream({
  event: {
    group: 'web-trip-tracker',
    classification: { instant: [] },
  },
  network: {
    url: process.env.REACT_APP_CLICKSTREAM_HOST_URL,
    headers: new Headers({
      Authorization: 'Basic ' + window.btoa(process.env.REACT_APP_CLICKSTREAM_KEY),
    }),
  }
})

export const ClickstreamContext = createContext(null);

export const useClickstream = () => {
  const context = useContext(ClickstreamContext);

  if (context === null) {
    throw new Error('useClickstream must be under ClickstreamProvider');
  }

  return context;
};

export const ClickstreamProvider = ({ children }) => {
  const getTimestamp = () => {
    const date = new Date();
    return Math.floor(date.getTime() / 1000);
  };

  const getDefaultPayload = () => {
    return {
      meta: {
        eventGuid: uuidv4(),
      },
      eventTimestamp: { seconds: getTimestamp() },
    };
  };

  const _track = async (properties) => {
    const { Component } = products.events.ui;
    const payload = Component.create(
      deepMergeObject(getDefaultPayload(), properties)
    );
    return clickstream.track(payload);
  };

  const _free = () => {
    return clickstream.free();
  };

  const _pause = () => {
    return clickstream.pause();
  };

  const _resume = () => {
    return clickstream.resume();
  };

  const value = {
    track: _track,
    pause: _pause,
    resume: _resume,
    free: _free,
  };

  return (
    <ClickstreamContext.Provider value={value}>
      {children}
    </ClickstreamContext.Provider>
  );
};
